import React from 'react';
import { Container } from 'library';

import Block from '../../blocks/Block';
import CMSContent from '../../common/CMSContent/CMSContent';
import PullQuote from '../../common/PullQuote/PullQuote';
import WistiaVideo from '../../common/WistiaVideo/WistiaVideo';
import Layout from '../../layout';

const TwoColumnRight = ({ data }) => {
  const { page } = data;
  const { title, content, templateFields } = page;
  const fields = templateFields.twoColumnRightFields;
  const blocks = templateFields.blocks;
  const quote = fields.blockQuote.length ? fields.blockQuote[0] : null;

  return (
    <Layout>
      <Container row justify="space-between" space={4}>
        <Container grid="5">
          <Container grid={10} style={{ padding: '0px' }}>
            {fields.wistiaVideoId && <WistiaVideo videoId={fields.wistiaVideoId} />}
            {quote && <PullQuote text={quote.text} name={quote.attribution?.name} title={quote.attribution?.title} />}
          </Container>
        </Container>
        <Container grid="7">
          {/*marginTop -1/2 of h1 line-height. Removes top line height effect to align the text and block quote  */}
          <h1 style={{ textAlign: 'left', marginTop: '-0.7rem' }}>{title}</h1>
          <CMSContent content={content} />
        </Container>
      </Container>

      {blocks?.map((block, index) => (
        <Block data={block} key={index} />
      ))}
    </Layout>
  );
};

export default TwoColumnRight;
